__webpack_require__.p = "https://master.d2g0kvh6wpax1o.amplifyapp.com/";